import "core-js/modules/es.array.concat.js";
import React from 'react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { Iframe } from './partials';
export var StorefrontCTA = function StorefrontCTA(_ref) {
  var tag = _ref.tag;
  if (!tag) {
    return null;
  }
  var pillURL = "".concat(getSuperPartnerBaseURL(), "/pills/es_ES/finect/default/products-leads/steps/productConsidered?storefront=").concat(tag);
  return React.createElement("div", null, React.createElement(LazyLoadComponent, null, React.createElement(Iframe, {
    height: "450",
    src: pillURL
  })));
};